module.exports = __webpack_public_path__ + "static/media/instrument2.b7318d93.jpg";